<template>
	<div>
		<a-modal v-show='ishand' id='touzhe' width='70rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">待成交單</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="max-height: 500px;padding-top: 2.8rem;">
				<div id='min-list'>
					<a-table style="width:100%;" :columns="columore" :data-source="columnsData" id='fromtable2' :scroll="{ y: 350 }"
						:pagination="false">
					</a-table>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['openstatic'],
		data() {
			return {
				visible: true,
				ishand: true,
				columore: [
					{
					title: '更改/取消',
					dataIndex: 'a',
					align: 'center',
					width: '8%',
				}, {
					title: '狀態',
					dataIndex: 'b',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '更改/取消',
					dataIndex: 'c',
					sorter: true,
					align: 'center',
					width: '9%',
				}, {
					title: '訂單編號',
					dataIndex: 'd',
					sorter: true,
					align: 'center',
					width: '7%',
				}, {
					title: '買/沽',
					dataIndex: 'e',
					sorter: true,
					align: 'center',
					width: '6%',
				}, {
					title: '市場',
					sorter: true,
					dataIndex: 'f',
					align: 'center',
					width: '5.5%',
				}, {
					title: '商品',
					dataIndex: 'g',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '類別',
					dataIndex: 'h',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '貨幣',
					dataIndex: 'i',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '價格',
					dataIndex: 'j',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '數量',
					dataIndex: 'k',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '價格',
					dataIndex: 'l',
					sorter: true,
					align: 'center',
					width: '5.5%',
				}, {
					title: '待成交訂單',
					dataIndex: 'm',
					sorter: true,
					align: 'center',
					width: '9%',
				}, {
					title: '已成交',
					dataIndex: 'q',
					sorter: true,
					align: 'center',
					width: '7%',
				}, {
					title: '最後更新',
					sorter: true,
					dataIndex: 'r',
					align: 'center',
					width: 'auto',
				}
				],
				columnsData: [],
			}
		},
		mounted() {
			// this.postdata()
		},
		watch:{
		},
		methods: {
			fanjiebao(val,to=2,num=1){
				//金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
				      var str = (val/num).toFixed(to) + '';
				      var intSum = str.substring(0,str.indexOf(".")).replace( /\B(?=(?:\d{3})+$)/g, ',' );//取到整数部分
				      var dot = str.substring(str.length,str.indexOf("."))//取到小数部分搜索
				      var ret = intSum + dot;
				      return ret;
				    //输出结果->20,000.00
			},
			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 36; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";
				var uuid = s.join("");
				return uuid;
			},
			postdata() {
				let obj = {
					client_acc_code: '1000005',
					localized_name: 'Y',
					// price:'',
					// exchange_code:"",
					// product_code:'',
				}
				let uuid = this.uuid()
				this.$ajax({
					method: 'post',
					url: this.$api.adminurls,
					contentType: '',
					data: {
						command: this.$axoisfix('portfolio', obj, uuid),
						language: 'big5',
						msgnum: uuid,
						token: "daca4cca-f334-4c26-8165-3f8d583e17fe",
						username: 1000005,
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						// App.oTool.successT();
						// 左側 rate 汇l
						
						this.arr1.map(ev=>{
							if(ev.c){
								ev.b = res.data.message[ev.c]
							}
						})
						if (res.data.message.cash_pos) {
							if (res.data.message.cash_pos.cash.constructor === Array) {
								this.arr2 = res.data.message.cash_pos.cash
							} else if (res.data.message.cash_pos.cash.constructor === Object) {
								this.arr2 = [res.data.message.cash_pos.cash]
							}
						}
					
						//右側列表
						if (res.data.message.product_pos) {
							if (res.data.message.product_pos.product.constructor === Array) {
								this.columnsData = res.data.message.product_pos.product
							} else if (res.data.message.product_pos.product.constructor === Object) {
								this.columnsData = [res.data.message.product_pos.product]
							}
						}
						this.columnsData.map(ev=>{
							ev.qty = this.fanjiebao(ev.qty,2)
							ev.price ='$' + this.fanjiebao(ev.price,3)
							ev.mv = this.fanjiebao(ev.mv,3)>0?this.fanjiebao(ev.mv,3):0
							ev.pl = this.fanjiebao(ev.pl,2)
						})
					} else {
						// App.oTool.warningT(res.data.qmismsg);
					}
					
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
		
		}
	}
</script>

<style lang="scss" scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.ckedf {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		left: 0;
		color: #fff;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfx {
		background-color: #fff;
		position: absolute;
		top: 1px;
		left: 2px;
		width: 11.1rem;
		height: 52.8px;
		line-height: 52.8px;
	}

	.ckedf1 {
		background-color: #0c8b97;
		position: absolute;
		top: 1px;
		right: 0;
		color: #fff;
		width: 7.5rem;
		height: 52.8px;
		line-height: 52.8px;
	}
	.ckedfs {
		background-color: #fff;
		position: absolute;
		top: 1px;
		right: 2px;
		width: 7.5rem;
		height: 52.8px;//2.79rem
		line-height: 52.8px;
	}

	.mark {
		margin-top: 1rem;
		background-color: #0c8b97;

		div {
			width: 7rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
			text-align: center;
			color: #fff;
		}
	}
</style>
<style lang="scss">
	.warp-abv{
		    background: #fff;
		    border: 1px solid #d8d8d8;
			height: 2rem;
			line-height: 2rem;
			cursor: pointer;
			color: #000 !important;
	}
	.centerdiv{
		border-top: 0;
		border-bottom:0 ;
	}
	.warp-abv:hover{
		background-color: #5cb1b9;
	}
	#touzhe {
		.ant-modal {
			top: 20vh;
		}
		.ant-table-body, .ant-table-content{
			border-left: .5px solid #e8e8e8;
			border-right: .5px solid #e8e8e8;
			border-top: .5px solid #e8e8e8;
		}
		.ant-table-placeholder{
			border-right: .5px solid #e8e8e8;
		}
		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem;
			}
		}

		.ant-table-column-title {
			font-weight: 600;
		}

		.ant-table-row-cell-break-word {
			color: #000;
		}

		#min-list {

			.ant-table-thead>tr>th,
			.ant-table-tbody>tr>td {
				padding: 16px 0;
			}
		}

		.ant-table-header-column {
			.ant-table-column-title {
				font-size: 0.85rem;
			}
		}

		.ant-modal-content {
			border-radius: 10px !important;
		}

		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}
	}
</style>
